module.exports = __webpack_public_path__ + "img/NorseCapTechDogMastery.e77a5840.webp";